import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextLink } from '@prismicio/next'

/**
 * Props for `TextPanel`.
 */
export type TextPanelProps = SliceComponentProps<Content.TextPanelSlice>;

/**
 * Component for "TextPanel" Slices.
 */
const TextPanel: FC<TextPanelProps> = ({ slice, context}) => {
  const contextData = context as any
  if(slice.primary.people_grid === true) {
    if(contextData?.setShowPanel === false) {
        return (
          <section
            data-slice-type={slice.slice_type}
            data-slice-variation={slice.variation}
            className={`${slice.primary.background_color?.toLowerCase()} px-4 md:px-16 lg:px-12 font-fellix `}>
            <div className={`max-w-[300px] md:max-w-[820px] mx-auto py-16`}>
              <article className={`max-w-none prose  ${slice.primary.large_text=== true ? "prose-p:text-[28px] prose-p:leading-[32px]":  "prose-p:text-[18px] prose-p:leading-[26px]"} ${slice.primary.background_color?.toLowerCase() !== 'orange' ? 'text-jade' :'prose-invert'} prose-h4:text-[18px]  prose-h4:leading-[24px] md:prose-h4:text-[28px] md:prose-h4:leading-[36px] prose-h4:font-fellix prose-h4:font-normal text-center`}>
                <PrismicRichText field={slice.primary.text}/>
              </article>
              {slice.primary.button_link?.link_type !=="Any" ?
                <div className="flex justify-center w-full mt-16 text-[18px]">
                  <PrismicNextLink field={slice.primary.button_link} className={slice.primary.button_color as any}>{slice.primary.button_text}</PrismicNextLink>
                </div>
              : <></>}
            </div>
          </section>
        )
    }
    return null
  }
  else  {
    return(
      <section
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
        className={`${slice.primary.background_color?.toLowerCase()} px-4 md:px-16 lg:px-12 font-fellix`}>
        <div className={`max-w-[300px] md:max-w-[820px] mx-auto py-24 ${slice.primary.top_pad === true ? "pt-24" : ""}`}>
          <article className={` max-w-none prose  ${slice.primary.background_color?.toLowerCase() !== 'orange' ? 'text-jade' :'prose-invert'} 
                                ${slice.primary.large_text=== true ? "prose-p:text-[28px] prose-p:leading-[32px]":  "prose-p:text-[18px] prose-p:leading-[26px]"}  prose-strong:font-semibold 
                                prose-h1:font-fellix prose-h5:font-normal prose-h1:leading-[110%] md:prose-h1:text-[48px] md:prose-h1:leading-[60px] prose-h1:font-semibold text-center
                                prose-h3:!m-0 prose-h3:!mb-12 prose-h3:text-[18px] prose-h3:leading-[24px] md:prose-h3:text-[28px] md:prose-h3:leading-[36px] prose-h3:font-fellix prose-h3:font-semibold
                                prose-h4:!m-0 prose-h4:!mb-12 prose-h4:text-[18px] prose-h4:leading-[24px] md:prose-h4:text-[28px] md:prose-h4:leading-[36px] prose-h4:font-fellix prose-h4:font-normal 
                                prose-h5:leading-[24px] md:prose-h5:text-[28px] md:prose-h5:leading-[36px] prose-h5:m-0 prose-h5:mb-5 break-words`}>
            <PrismicRichText field={slice.primary.text}/>
          </article>
          {slice.primary.button_link?.link_type !=="Any" ?
          <div className="flex justify-center w-full mt-16 text-[18px] text-center ">
            <PrismicNextLink field={slice.primary.button_link} className={slice.primary.button_color as any}>{slice.primary.button_text}</PrismicNextLink>
          </div>
          : <></>}
      </div>
    </section>
    )}
};

export default TextPanel;



